import React from "react";
import bitsIcon from "../../../../../assets/images/bits_icon.svg";
import BottomBar from "../../BottomBar/BottomBar";
import style from "./CheerConfettiBottomBar.module.scss";

interface CheerConfettiBottomBarProps {
  bitsAmount: string | number;
}

const CheerConfettiBottomBar: React.FC<CheerConfettiBottomBarProps> = ({ bitsAmount }) => {
  return (
    <BottomBar>
      <img src={bitsIcon} />
      <div className={style.cheerConfettiBottomBar}>
        <h1 className={style.cheerConfettiBottomBar__title}>Yay!</h1>
        <p className={style.cheerConfettiBottomBar__text}>You just used {bitsAmount} bits!</p>
      </div>
      <img src={bitsIcon} />
    </BottomBar>
  );
};

export default CheerConfettiBottomBar;
